
/**
 * Permite obtener las horas en las cuales el usuario podrá acceder al sistema
 * @param from Hora inicio de jornada laboral
 * @param to Hora fin de jornada laboral
 * @returns []: bloqueo de acceso | null: acceso a cualquier hora | number[]: horas de acceso definidas
 */
export function hoursBetweenRange(from: number|undefined, to: number|undefined): null | number[] {
    if(!!!from || !!!to)
        return null
    const hoursArray: number[] = []
    if (from !== to) {
        for (let hours = from; hours <= to; hours++) {
            hoursArray.push(hours)
        }
        return hoursArray
    }
    return null
}

interface DiasPermitidosInterface {
    dia: number;
    horas: number[];
}
/**
 * Obtiene el formato en que se enviarán los datos para el campo dias_permitidos
 * @param enabledHours Horas en las que el usuario labora
 * @param enabledDays Array de días en números (Lunes=1, Martes=2 ...) 
 * @returns diasPermitidosInterface[] | [] 
 */
export function getDiasPermitidos(enabledHours: number[], enabledDays: number[]): DiasPermitidosInterface[] {
    const diasPermitidos: DiasPermitidosInterface[] = []
    if (enabledHours.length > 0 && enabledDays.length > 0) {
        enabledDays.forEach((item) => {
            diasPermitidos.push({
                "dia": item,
                "horas": enabledHours
            })
        })
    }
    return diasPermitidos
}

/**
 * Devuelve la hora de inicio y fin a partir del array de horas en las que se trabaja
 * @param hoursInWork Array con horas en las cuales se labora
 * @returns [ horaInicio, horaFin ]
 */
export function getTimesForClockInWorkSchedules(hoursInWork: number[]) {
    if (hoursInWork) {
        let auxHoraInicio = new Date()
        let auxHoraFin = new Date()
        auxHoraInicio.setHours(hoursInWork[0])
        auxHoraInicio.setMinutes(0)
        auxHoraFin.setHours(hoursInWork[(hoursInWork.length) - 1])
        auxHoraFin.setMinutes(0)
        return [auxHoraInicio, auxHoraFin]
    }
    return [null, null]
}